import { MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

import { settings } from "~/config/i18n";

export default function LanguagePicker() {
    const { i18n } = useTranslation("app");

    const handleMenuItemClick = (language: string) => {
        i18n.changeLanguage(language);
    };

    return (
        <Select
            value={i18n.language}
            onChange={event => handleMenuItemClick(event.target.value)}
            sx={{ width: "100%" }}
        >
            {settings.map(({ label, value }) => (
                <MenuItem
                    key={label}
                    value={value}
                    onClick={() => handleMenuItemClick(value)}
                    selected={i18n.language === value}
                >
                    {label}
                </MenuItem>
            ))}
        </Select>
    );
}
